module.exports = __webpack_public_path__ + "static/img/bg.a553009.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/activity4/bg.jpg
// module id = ielU
// module chunks = 7